
export const SET_CLIENTS = 'SET_CLIENTS'
export const SET_CLIENT = 'SET_CLIENT'
export const SET_META = 'SET_META'
export const SET_CLIENT_ORDERS = 'SET_CLIENT_ORDERS'
export const SET_CLIENT_ORDERS_OLD = 'SET_CLIENT_ORDERS_OLD'
export const SET_CLIENT_ORDERS_OLD_META = 'SET_CLIENT_ORDERS_OLD_META'
export const SET_CLIENT_ORDERS_META = 'SET_CLIENT_ORDERS_META'
export const SET_CLIENT_ORDERS_PRODUCTS = 'SET_CLIENT_ORDERS_PRODUCTS'
export const SET_CLIENT_ORDERS_PRODUCTS_META = 'SET_CLIENT_ORDERS_PRODUCTS_META'
export const SET_ORDERS_META = 'SET_ORDERS_META'
export const SET_SEARCH_FILTERS = 'SET_SEARCH_FILTERS'
export const SET_ORDERS_SEARCH_FILTERS = 'SET_ORDERS_SEARCH_FILTERS'
export const UPDATE_CLIENT_FORM = 'UPDATE_CLIENT_FORM'
export const CLEAR_CLIENT_FORM = 'CLEAR_CLIENT_FORM'
export const SET_LOADING = 'SET_LOADING'
export const SET_CLIENTS_STATISTICS = 'SET_CLIENTS_STATISTICS'
export const SET_CLIENT_STATISTICS = 'SET_CLIENT_STATISTICS'
